import { useState, useEffect } from 'react';

function useOnResize(ref, onResize) {
  var _useState = useState(null),
      rect = _useState[0],
      setRect = _useState[1];

  useEffect(function () {
    if (!ref.current) {
      return;
    }

    var currentRect = ref.current.getBoundingClientRect();
    setRect(currentRect);
  }, [ref]);
  useEffect(function () {
    if (!ref.current) {
      return;
    }

    function handleResize() {
      var currentRect = ref.current.getBoundingClientRect();

      if (!rect) {
        setRect(currentRect);
        onResize(currentRect);
        return;
      }

      if (rect.width !== currentRect.width || rect.height !== currentRect.height) {
        setRect(currentRect);
        onResize(currentRect);
      }
    }

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, [ref, rect, onResize]);
}

export default useOnResize;